import React, { useEffect, useState } from "react";

import styles from '../../css/rulesAndPolicy.module.css'


function Sentence(){

  const sentences = [
  "„Prawdziwe życie zaczyna się tam, gdzie kończy się komfort.” – Anaïs Nin",
  "Kiedy masz zabic człowieka, uprzejmośc nic nie kosztuje (Winston Churchill)",
  "Nie uważałeś, jak robisz, więc rób jak uważasz (Ludwik Puget, na pytanie syna, co robić z niechcianą ciążą)",
  "Zważmy zysk i stratę, zakładając, że Bóg istnieje. Jeśli wygrasz, zyskujesz wszystko; jeśli przegrasz nie tracisz nic. (Pascal)",
  "Wiekuista cisza tych nieskończonych przestrzeni przeraża mnie. (Słowa które wypowiedział PAscal, patrząc w niebo w gwieździstą noc )",
  "„Największe wydarzenia w historii świata to tragedie, które przeżywamy zbyt późno, aby je zmienić.” – Friedrich Nietzsche",
  "Człowiek jest bogiem, kiedy śni, i tylko żebrakiem, kiedy myśli. (Hoelderlin)",
  "Cudze życie - tak daleko. (Antoine de Saint-Exupéry)",
  "Bogowie są nieśmiertelnymi ludźmi, ludzie śmiertelnymi bogami. (Heraklit)",
  "Dziennikarze nie interesują się wcale wiadomościami, które podają, tak jak kelnerzy nie mają apetytu na potrawy, które przynoszą. (Hugo Steinhaus)",
  "Boję się człowieka czerpiącego wiedzę z jednej książki. (Tomasz z Akwinu)",
  "„Mądrość zaczyna się w zdziwieniu.” – Sokrates",
  "Nigdy nie przeszkadzaj przeciwnikowi, kiedy popełnia błąd. (Napoleon Bonaparte)", 
  "„Życie to coś, co się nam wymyka, gdy skupiamy się na jego planowaniu.” – Seneka",
  "’W okopach nie ma ateistów’ – to nie argument przeciwko ateizmowi, to argument przeciwko okopom. (James Morrow)",
  "Twoja broń wyprodukował ten, kto zaproponował najniższą cenę w przetargu", 
  "Jeśli przechodzisz przez piekło… nie zatrzymuj się. (Winston Churchill)",
  "Żeby zło odniosło sukces wystarczy, żeby dobrzy ludzie nic nie robili. (Edmund Burke)",
  "Całość to więcej niż suma jej składników. (Arystoteles)",
  "„Odważni żyją wiecznie — tchórze umierają codziennie.” (Cyceron)",
  "Jeśli chcesz osiągnąć wielkość — działaj, jakby porażka była niemożliwa. (Napoleon)",
  "Mędrzec nie mówi tego co wie, głupiec nie wie co mówi. (Przysłowie tureckie)",
  "Grzeszyć to nie znaczy czynić zło. Grzeszymy naprawdę, nie czyniąc dobra. (Pier Paolo Pasolini)",
  "„Na wojnie prawda jest pierwszą ofiarą.” – Ajschylos",
  "Moim zdaniem, jako lekarza, jest pomóc pacjentowi w zmaganiu się z życiem. (Carl Gustav Jung)",
  "„Nikt nie kocha życia bardziej niż ci, którzy najczęściej ryzykują.” (Sofokles)",
  "„Strach zabija szybciej niż miecz.”",
  "Logika to sztuka popełniania błędów z dużą dozą pewności siebie. (Anonim)",
  "Nie wystarczy zdobywać mądrości, trzeba jeszcze z niej korzystać. (Cyceron)",
  "Nadzieja jest nieufnością człowieka wobec przewidywań jego umysłu. (Paul Valéry)",
  "„Ten, kto się waha, już przegrał.” — Tacitus",
  "My Niemcy boimy się Boga, ale nikogo więcej na świecie. (Otto von Bismarck)",
  "Miliony ludzi marzą o nieśmiertelności: to ci sami ludzie, którzy nie wiedzą co ze sobą zrobić w deszczowe niedzielne popołudnie. (Susan Ertz)",
  "Opinia publiczna to potrawa przyrządzana przez nielicznych, ale bardzo zręcznych kucharzy. (Ezra Pound)",
  "Pesymista to dobrze poinformowany optymista. (Czeskie powiedzenie)",
  "Bóg mi wybaczy to jego fach. (Heinrich Heine)",
  "Chopin, gdyby jeszcze żył, to by pił. (Wyspiański)",
  "Jadąc za morze niebo zmieniamy, nie duszę. (Horacy)",
  "Pożyteczna praca jest zawsze cicha i niezauważalna. (Tołstoj)",
  "Im bardziej chore jest państwo, tym więcej w nim praw. (Tacyt)",
  "Ból życia jest znacznie potężniejszy od zainteresowania życiem. Oto dlaczego religia będzie zawsze zwyciężać filozofię. (Rozanow)",
  "Rewolucje nie toczą się o drobiazgi. Rewolucje wszczyna się o drobiazgi. (Arystoteles)",
  "Gdy rozum śpi, budzą się upiory. (Goya)",
  "W każdym z nas jest ktoś, kogo nie znamy. Przemawia do nas w snach i tłumaczy, że widzi nas zupełnie inaczej, niż my siebie. (Carl Gustav Jung)",
  "Sukces w oczach ludzi jest bogiem. (Ajschylos)",
  "Potrafię współczuć cudzym bólom, ale nie przyjemnościom. Jest coś dziwnie nudnego w szczęściu innych ludzi. (Huxley)",
  "Sztuka trwa - życie przemija. (Hipokrates)",
  "Mówi się, że gdyby to Szwajcarzy zaprojektowali Alpy, byłyby o wiele bardziej płaskie. (Paul Theroux)",
  "Są na świecie bandyci i święci. Ale święci obracają się w ramach, które wyznaczają bandyci. (Elzenberg)",
  "Tradycja to piękno, które chronimy, a nie więzy, które nas krępują. (Ezra Pound)",
  "Wiedza tylko wtedy jest wiedzą, kiedy zdobyta została wysiłkiem własnej myśli, a nie wyłącznie dzięki pamięci. (Tołstoj)",
  "Na tym świecie istnieje tylko jedna alternatywa: rozkazywać albo słuchać. (Napoleon)",
  "Jeśli chcesz pokoju, gotuj się do wojny. (Platon)",
  "Kto w wolności szuka czegoś więcej niż ona sama, ten został stworzony na niewolnika. (Tocqueville)",
  "Nawet Mojżesz nie mógł dać sobie rady z Żydami. (Przysłowie jidysz)",
  "Rzeźba jest już w kamieniu, ja tylko odcinam to, co zbędne. (Michał Anioł)",
  "Ja nie szukam, ja znajduję. (Pablo Picasso)",
  "Gdyby Bóg nie istniał, należałoby go wymyślić. (Voltaire)",
  "Każdy bohater staje się w końcu nudziarzem. (Ralph Waldo Emerson)",
  "Nawet gwiazdy płaczą razem z tym, kto płacze w nocy. (Talmud)",
  "Człowiek... to jedyne zwierzę, które się rumieni, kiedy myśli. (Hoelderlin)",
  "Największą krzywdę wyrządzamy temu, kim zajmujemy się bez reszty. (Elias Canetti)",
  "Przebiegłość diabła w tym najbardziej się objawia, że przekonuje ludzi o swym nieistnieniu. (Baudelaire)",
  "Takt polega na tym, by wiedzieć, jak daleko można się posunąć, by nie posunąć się za daleko. (Cocteau)",
  "Człowiek wytwarza zło, jak pszczoła miód. (William Golding)",
  "W dyktaturze każdy boi się każdego, a jeden boi się najbardziej. (Pier Paolo Pasolini)",
  "Kiedy dyplomata mówi 'tak', oznacza to 'może', kiedy mówi 'może' ma na myśli 'nie', kiedy mówi 'nie' - nie jest dyplomatą.",
  "Film nie jest sztuką uczonych, lecz analfabetów. (Werner Herzog)",
  "Dla religii tylko to jest prawdziwe, co jest święte; dla filozofii tylko to jest święte, co prawdziwe. (Ludwig Feuerbach)",
  "Ambicja to ostatni bastion porażki. (Oscar Wilde)",
  "Nie ma geniuszu bez ziarna szaleństwa. (Arystoteles)",
  "Ograniczony umysł wyżywa się w nieograniczonych ambicjach. (Drobnik)",
  "Przyzwyczajenie jest naszą drugą naturą. (Cyceron)",
  "Śmierć generała to tragedia, śmierć milionów żołnierzy to statystyki. (Józef Stalin)",
  "Jeśli człowiek nie jest pewny swej dobrej pamięci, nie powinien ważyć się na kłamstwo. (Montaigne)",
  "Pokój bez książek jest jak ciało bez duszy. (Cyceron)",
  "Nie sposób naprawdę cieszyć się leniuchowaniem, jeżeli nie ma mnóstwa zaległej pracy. (Jerome)",
  "Przeciwności losu uczą mądrości, powodzenie ją odbiera. (Seneka)",
  "Bywają pochwały gorsze od nagany",
  "„Nie ma większej samotności niż w tłumie.” – Blaise Pascal",
  "Człowiek staje się stary, gdy inni zaczynają mu mówić, że młodo wygląda. (zasłyszane)",
  "Widzę i pochwalam lepsze, lecz wybieram gorsze. (Owidiusz)",
  "Nauka jest cmentarzyskiem obumarłych idei. (Miguel de Unamuno)",
  "Życie pośmiertne to najbardziej dochodowa fikcja, o jakiej wiem. (William H. Gass)",
  "Opinia publiczna to dziwka. (Napoleon Bonaparte)",
  "Pesymista twierdzi, że wszystkie kobiety to nierządnice. Optymista nie jest tego zdania, ale ma nadzieję. (Julian Tuwim)",
  "Umieram z pomocą zbyt wielu lekarzy. (Aleksander Wielki)",
  "Zbyt piękne odsłania pustkę. (Stanisław Ignacy Witkiewicz)",
  "Tylko w spokojnym stawie odbija się światło gwiazd. (Konfucjusz)",
  "Najtrudniejsze dzieło świata od łatwego trzeba rozpocząć, a największe dokonania od drobiazgów. (Laozi)",
  "Strzeż się psychoanalityka, który zamiast się śmiać z żartów, analizuje je. (Thomas Shaw)",
  "Pycha, która skłania nas do tworzenia raju na ziemi powoduje, że zmieniamy naszą poczciwą ziemię w piekło. (Karl Popper)",
  "Nie potrafimy powiedzieć czym jest rzeczywistość; potrafimy jedynie powiedzieć, jaką nam się wydaje. (Gaston Bachelard)",
  "Rewolucja, jak Saturn, pożera swe własne dzieci. (Georg Büchner)",
  "Serce ma swoje racje, których rozum nie zna. (Pascal)",
  "Kiedy płonie dom sąsiadów, stawką jest twój własny dom. (Horacy)",
  "Sukces jest najgłośniejszym mówcą świata. (Napoleon Bonaparte)",
  "Wykształcenie to to, co pozostaje kiedy zapomina się rzeczy wyuczonych. (B.F. Skinner)",
  "Pieniądz jest nerwem wojny. (Cyceron)",
  "Zaiste, drżę o swój kraj, gdy pomyślę, że Bóg jest sprawiedliwy. (Thomas Jefferson)",
  "Księżyc pożycza światło od słońca. (Tales z Miletu)",
  "To nie świat stał się o wiele gorszy, to serwis informacyjny jest o wiele lepszy. (G.K. Chesterton)",
  "Filozofować to uczyć się umierać. (Montaigne)",
  "Naprzód spójrz z kim jesz i pijesz, a dopiero potem co jesz i pijesz. (Epikur)",
  "Bogactwo nie jest ulgą w kłopotach, tylko zmianą kłopotów. (Epikur)",
  "Więcej bredni powiedzieć może głupiec w pięciu minutach niż mędrzec przez pięć lat odgadnąć. (Irzykowski)",
  "Bóg umarł - Nietzsche. Nietzsche umarł - Bóg. (napis w metrze w Nowym Jorku)",
  "Tu przebywają lwy - tak na dawnych mapach oznaczano miejsca nieznane",
  "Odwaga jest to wiedza o tym, czego się bać, a czego nie. (Platon)",
  "Każdy człowiek prowadzi jakąś kalkulację, którą nazywamy nadzieją. (Platon)",
  "Dobrzy ludzie to ci, którzy zadawalają się marzeniami o tym, co źli naprawdę robią.",
  "Nieszczęście wynika z braku rozumu. (Diogenes z Synopy)",
  "Człowiek mądry więcej uczy się od swych wrogów, niż głupiec od przyjaciół. (Benjamin Franklin)",
  "Człowiekiem jestem i nic co ludzkie nie jest mi obce. (Terencjusz)",
  "Tłum był wielki, ale ludzi niewielu. (Diogenes z Synopy, o igrzyskach)",
  "Trudno się do tego przyznać, ale oddałbym dziesięć rozmów z Einsteinem za pierwszą randkę z piękną tancerką. (Camus)",
  "Przestaje się być młodym kiedy się rozumie, że wyjawienie bólu niczego w istocie nie zmienia. (Pavese)",
  "Szukam człowieka. (Diogenes z Synopy, chodząc z pochodnią w dzień)",
  "Hominem te memento - pamiętaj, że jesteś tylko człowiekiem. (Wulgata, powtarzane przez niewolnika w Rzymie)",
  "Ludzi głupich ze smutku wyzwala czas, mądrych logika.",
  "Wino czyni ubogiego bogatym w fantazje, a bogatego biednym w rzeczywistość. (Platon)",
  "Dziwną rzeczą jest, że ludzie zawsze umieją powiedzieć ile posiadają owiec, natomiast nie potrafią podać liczby przyjaciół - tak nisko ich cenią.",
  "Kości zostały rzucone. (Juliusz Cezar)",
  "Odstraszają mnie ślady (innych, którym się nie powiodło)",
  "Wszystkie ranią, ostatnia zabija. (Dawne zegary)",
  "Broda mędrcem nie czyni.",
  "Dajcie mi odpowiednio długą dźwignię i wystarczająco mocną podporę, a sam poruszę cały glob. (Archimedes)",
  "Poza tym uważam, że Kartagina powinna zostać zburzona. (Katon)",
  "Nieznajomość prawa szkodzi.",
  "Bywają pochwały gorsze od nagany.",
  "U początku filozofii i nauki stoi zdziwienie. (Arystoteles)",
  "Z życia najlepiej odchodzić jak od uczty, ani spragnionym, ani pijanym. (Arystoteles)",
  "Wszystko powinno się upraszczać na ile to możliwe, ale nie bardziej. (Albert Einstein)",
  "W niebie anioł nie jest nikim nadzwyczajnym. (Fredo)",
  "Mowa jest srebrem, milczenie złotem. (Cyceron)",
  "Doświadczenie stworzyło sztukę, brak doświadczenia przypadek. (Arystoteles)",
  "Diem perdidi - straciłem dzień. (Tytus)",
  "Gdy dwaj robią to samo, to nie jest to samo.",
  "Od wzniosłości do śmieszności tylko jeden krok. (Napoleon)",
  "A jednak się porusza! (Galileusz)",
  "Popełnić błąd jest przywilejem ludzi mądrych, tylko głupcy nie mylą się nigdy. (Sokrates)",
  "Est modus in rebus - mają rzeczy swą miarę. (Horacy)",
  "Gnóthi seautón - Poznaj siebie samego. (Świątynia Apollina w Delfach)",
  "Kropla drąży skałę nie siłą, lecz ciągłym padaniem. (Owidiusz)",
  "W śród ślepców, jednooki jest królem",
  "Dziel i rządź i siej niezgodę, abyś mógł łatwiej rządzić",
   "Wystarczyło jednej chwili aby ściąć tę głowę, ale żeby druga taka się narodziła, może nie starczyć stu lat. (Gaspard Monge, o Lavoisierze)",
  "Witaj Cezarze, mający umrzeć, pozdrawiają Cię. (Gladiatorzy)",
  "Uda się. (Pieśń z czasów rewolucji francuskiej)",
  "Bóg tak chce. (Krucjaty)",
  "Mądrej głowie dość dwie słowie. (Plaut)",
  "Żaden autor nie jest geniuszem w oczach swojego wydawcy. (Hein)",
  "Obym był fałszywym prorokiem. (Liwiusz)",
  "Drogi mi Platon, drogi mi Sokrates, ale jeszcze droższa prawda. (Arystoteles)",
  "Jest niewiele cnót, których Polacy nie posiadają i niewiele pomyłek, których udało im się uniknąć. (Winston Churchill)",
  "Zawsze coś przylgnie. (Plutarch, o skuteczności oszczerstw)",
  "Jak mogę interesować się pracą, skoro jej nie lubię. (Francis Bacon)",
  "Nie można wejść dwa razy do tej samej rzeki. (Heraklit z Efezu)",
  "Gdy amfora pusta, przyjaciele rozchodzą się. (Horacy)",
  "Choroba pozwala poznać słodycz zdrowia. (Heraklit z Efezu)",
  "Przyszłość: czas, w którym interesy idą nam świetnie, nasi przyjaciele są wierni, i nasze szczęście jest zapewnione. (Bierce)",
  "Wszyscy ludzie, którzy naprawdę wierzą w siebie, znajdują się w domach wariatów. (Chesterton)",
  "Natura lubi się ukrywać. (Heraklit)",
  "Religie umierają, kiedy udowodniona zostaje ich prawdziwość. Nauka jest zapisem martwych religii. (Oscar Wilde)",
  "Uważajcie, bo mają broń, a nie mają wyjścia. (Ryszard Kapuściński)",
  "Kto nie dąży do rzeczy niemożliwych, nigdy ich nie osiągnie. (Heraklit z Efezu)",
  "W życiu nie ma nic stałego poza zmianą. (Heraklit z Efezu)",
  "Przyzwyczajenie jest drugą naturą. (Cyceron)",
  "W dowolnym kolorze pod warunkiem że w czarnym. (Henry Ford)",
  "Kiedy spoglądasz w otchłań, ona również patrzy na ciebie. (Nietzsche)",
  "Gdybyś milczał, nadal uważali by Cię za mędrca.",
  "Człowiek niezastąpiony to dowód duchowego ubóstwa społeczeństwa. (Stefan Kisielewski)",
  "Móc czegoś nie chcieć to już jest szczęście. (Dąborowska)",
  "Mam zamiar przenieść się do Szwajcarii. Zawsze marzyłem o kraju, w którym góry są wyższe od podatków. (Cendrars)",
  "Że śmierć jest złem, tego zdania są nawet bogowie, skoro sami nie umierają. (Safona)",
  "Gwardia umiera, lecz się nie poddaje. (Cambrone)",
  "Porzućcie wszelką nadzieję, wy którzy tu wchodzicie. (Dante)",
  "Policzone, zważone, rozdzielone. (Przepowiednia upadku Babilonu)",
  "Lekarzu, ulecz samego siebie. (Wulgata)",
  "Lekarz leczy, natura uzdrawia.",
  "Najbezpieczniej jest chodzić środkiem. (Owidiusz)",
  "Więcej światła. (Goethe)",
  "Panta rhei - wszystko płynie. (Heraklit z Efezu)",
  "Głupiec uczony, jest większym głupcem niż głupiec nieuk. (Molier)",
  "Nie mogę uwierzyć, że Bóg gra w kości z wszechświatem. (Einstein)",
  "Nikt nie jest prorokiem we własnej ojczyźnie. (Wulgata)",
  "Nulla nuova, buona nuova - już sam brak wiadomości oznacza dobre wiadomości.",
  "Nie wszystek umrę. (Horacy)",
  "Wiem, że nic nie wiem. (Sokrates)",
  "Żołnierze pamiętajcie, że z wierzchołka tych piramid 40 wieków na was patrzy. (Napoleon, przed bitwą pod piramidami)",
  "W czasie wojny milkną prawa. (Cyceron)",
  "Sprawiedliwość waszą sądzić będę. (Dawna Polska)",
  "Zachowaj nas Boże od takich sędziów.",
  "Bardziej obawiam się trzech gazet niż stu tysięcy bagnetów. (Napoleon Bonaparte)",
  "„Natura nie kłamie, ale uogólnienia już tak.” – parafraza stoicka",
  "Myślę więc jestem. (Kartezjusz)",
];

  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0); 
  const diff = now - start; // różnica w ms
  const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));

  const todayIndex = dayOfYear % sentences.length;


  return(
         <div className={`${styles.quoteContener}  userSelectNone`}>
          <div className={styles.quoteTitle}>
            <em><span>🏛️ </span> Cytat dnia:</em>
          </div>
          <div className={styles.dailyQuoteContainer}>
            <div className={styles.leftIcon}>🌿</div>
            <div className={styles.textWrapper}>
              <div className={styles.ticker}>
                 <span>{sentences[todayIndex]}</span>
                 <span>{sentences[todayIndex]}</span>
              </div>
              
            </div>
            <div className={styles.rightIcon}>🌿</div>
          </div>
        </div>
  )

}

export default Sentence


